export const FETCH_PRODUCTS_REQUESTED = 'FETCH_PRODUCTS_REQUESTED';
export const FETCH_PRODUCTS_SUCCEEDED = 'FETCH_PRODUCTS_SUCCEEDED';
export const FILTER_PRODUCT_REQUESTED = 'FILTER_PRODUCT_REQUESTED';
export const FILTER_PRODUCT_SUCCEEDED = 'FILTER_PRODUCT_SUCCEEDED';
export const MAP_CATEGORIES_TO_PRODUCTS = 'MAP_CATEGORIES_TO_PRODUCTS';
export const DOWNLOAD_REQUESTED = 'DOWNLOAD_REQUESTED';
export const DOWNLOAD_SUCCESSED = 'DOWNLOAD_SUCCESSED';
export const FILTER_PRODUCTS_BY_STATUS = 'FILTER_PRODUCTS_BY_STATUS';
export const UPDATE_MULTI_PRODUCT_STATUS_REQUESTED = 'UPDATE_MULTI_PRODUCT_STATUS_REQUESTED';

export const FETCH_PARTNER_PRODUCT_REQUESTED = 'FETCH_PARTNER_PRODUCT_REQUESTED';
export const FETCH_PARTNER_PRODUCT_SUCCEEDED = 'FETCH_PARTNER_PRODUCT_SUCCEEDED';

export const SEND_PRODUCT_TO_PARTNER_QUEUE_REQUESTED = 'SEND_PRODUCT_TO_PARTNER_QUEUE_REQUESTED';
export const SEND_PRODUCT_TO_PARTNER_QUEUE_SUCCEEDED = 'SEND_PRODUCT_TO_PARTNER_QUEUE_SUCCEEDED';

export const BULK_UPDATE_PRODUCT_REQUESTED = 'BULK_UPDATE_PRODUCT_REQUESTED';
export const BULK_UPDATE_PRODUCT_COMPLETE = 'BULK_UPDATE_PRODUCT_COMPLETE';
export const BULK_UPDATE_PRODUCT_FAILED = 'BULK_UPDATE_PRODUCT_FAILED';
export const BULK_UPDATE_PRODUCT_SUCCEEDED = 'BULK_UPDATE_PRODUCT_SUCCEEDED';

export const REINDEX_PRODUCT_REQUESTED = 'REINDEX_PRODUCT_REQUESTED';
export const REINDEX_PRODUCT_SUCCEEDED = 'REINDEX_PRODUCT_SUCCEEDED';
export const REINDEX_PRODUCT_COMPLETED = 'REINDEX_PRODUCT_COMPLETED';

export const REINDEX_SELECTED_PRODUCT_ITEM = 'REINDEX_SELECTED_PRODUCT_ITEM';
export const SELECT_ALL_VISIBLE_PRODUCT = 'SELECT_ALL_VISIBLE_PRODUCT';

export const SELECT_ALL_PRODUCT = 'SELECT_ALL_PRODUCT';

export const RESET_PRODUCT_SELECTION = 'RESET_PRODUCT_SELECTION';

export const START_GLOBAL_SALE_REQUESTED = 'START_GLOBAL_SALE_REQUESTED';
export const STOP_GLOBAL_SALE_REQUESTED = 'STOP_GLOBAL_SALE_REQUESTED';
